<template>
  <router-link
    class="home-last-lesson-card border-0"
    :to="{
      name: 'lesson',
      params: { ...lesson.module, lesson: lesson.id }
    }"
  >
    <div>
      <div
        class=" img mb-1"
        :style="backgroundImage"
        :class="{ 'no-cover-and-placeholder': !backgroundImage }"
      >
        <div class="progress flex-fill">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="`width: ${progress}%`"
          ></div>
        </div>
        <div class="velora-placeholder" v-if="!backgroundImage">
          <img class="img-partner-placeholder" :src="$setup.partnerLogo" />
        </div>
      </div>
    </div>
    <div class="lesson-description">
      <small class="lesson-name mb-2">
        {{ lesson.name }}
      </small>

      <small class="module-name font-weight-normal">
        {{ lesson.module.name }}
      </small>
    </div>
  </router-link>
</template>

<script>
import { youtubeParser } from "@/functions/helpers";

export default {
  props: {
    lesson: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    progress() {
      if (!this.lesson.duration) return 0;

      const seconds = this.lesson.duration * 60; //cast duration (in minutes) to seconds
      return Math.round((100 * this.lesson.progress.stopped_at) / seconds);
    },
    backgroundImage() {
      let image = this.lesson.picture || this.$setup?.setup?.placeholder_lesson;

      if (!image && this.lesson.link_media.includes("youtu")) {
        image = `https://i.ytimg.com/vi/${youtubeParser(
          this.lesson.link_media
        )}/hqdefault.jpg`;
      }

      return image ? `background-image: url(${image})` : ``;
    }
  },
  methods: {
    onClick() {
      this.$router.push({
        name: "module",
        params: {
          ...this.lesson.module
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-last-lesson-card {
  text-align: left;
  padding: 0;
  border-radius: 16px;
  width: 100%;

  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }

  .img {
    height: 0;
    width: 100%;
    display: block;
    padding-bottom: 55%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    background-color: #151823;
    border-radius: 4px;
    position: relative;
  }

  .progress {
    height: 4px;
    width: 100%;
    background: none;
    position: absolute;
    bottom: 0;
    left: 0;

    .progress-bar {
      border-radius: 0px 8px 8px 0px;
      height: 4px;
    }
  }

  .lesson-name,
  .module-name {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    min-width: 0;
    font-size: 12px;
    font-weight: 600;
    line-height: 150%;
  }

  .lesson-description {
    display: grid;
    padding-top: 8px;
  }

  .velora-placeholder {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .img-partner-placeholder {
    max-width: 42px;
    max-height: 42px;
    min-width: 42px;
    min-height: 42px;
    padding-top: 15%;
  }
}
</style>
